import {
  DroppsProduct,
  DroppsVariant,
  productSelect,
  variantSelect,
} from "@/store";
import { Discount, BoxItem } from "./types";
import { Money, $ } from "@/helpers/Money";

export function boxTotals(items: BoxItem[], discount?: Discount) {
  let amountSaved = Money.zero;
  let freeShip = false;

  const lineItemsPrice = items.reduce(
    (acc, x) => x.rechargeItem.price.mul(x.rechargeItem.quantity).add(acc),
    Money.zero
  );

  if (discount) {
    if (discount.kind === "freeShipping") {
      freeShip = true;
    } else if (discount.kind === "percent") {
      amountSaved = lineItemsPrice.mul(discount.value / 100);
    } else {
      amountSaved = Money.from(discount.value, "$");
    }
  }

  const discountedLineItems = lineItemsPrice.sub(amountSaved).max(Money.zero);
  const shippingWeight = items.reduce(
    (acc, x) => acc + x.variant.weight.asPounds() * x.rechargeItem.quantity,
    0
  );

  freeShip ||= discountedLineItems >= $`35`;
  const shipping = freeShip ? Money.zero : shippingWeight < 1 ? $`5` : $`10`;
  const estimatedTotal = discountedLineItems.add(shipping);
  return {
    discounts: amountSaved,
    lineItemsPrice: lineItemsPrice,
    shipping: shipping,
    discountedLineItems,
    estimatedTotal,
  };
}

export const droppsProductToProductCardProduct = ({
  product,
  variant,
}: {
  product: DroppsProduct;
  variant: DroppsVariant;
}) => {
  return {
    featuredImage: {
      src: productSelect.featuredImage(product).url,
      width: 80,
      height: 80,
    },
    title: product.title,
    size: variantSelect.sizeFormat(variant),
  };
};

export const getDisplayDate = (
  date: Date,
  options?: Intl.DateTimeFormatOptions
) => {
  return date.toLocaleDateString("en-us", {
    year: "numeric",
    month: "long",
    day: "numeric",
    ...options,
  });
};
